import { z } from 'zod'

/**
 * When a piece of tree work should be done.
 *
 * A season, not a date: an arborist under a tree knows dormant oil goes on in
 * winter, not which week the crew will be free. Shown by name only, never
 * with a year (docs/seasonal-work.md).
 *
 * In the order the year runs, starting from winter. That order is what "the
 * next season with work" counts through, so it is not alphabetical.
 *
 * Mirrors the `Season` enum in api/prisma/schema.prisma.
 */
export const SEASONS = ['WINTER', 'SPRING', 'SUMMER', 'FALL'] as const

export const seasonSchema = z.enum(SEASONS)

export type Season = z.infer<typeof seasonSchema>

export const SEASON_LABELS: Record<Season, string> = {
  WINTER: 'Winter',
  SPRING: 'Spring',
  SUMMER: 'Summer',
  FALL: 'Fall',
}
